export const build = { date:"2026-06-10.1818", stage:"alpha" }
